<template>
  <div class="free">
    <el-button icon="el-icon-refresh" @click="$refresh(getSchedulesData)" class="refresh-btn">刷新</el-button>
    <div class="wrap">
      <!-- 条件查询 -->
      <div class="search">
        <el-form inline :model="searchForm">
          <el-form-item label="医生姓名">
            <el-select allow-create clearable v-model="searchForm.doctorName" placeholder="请选择医生" filterable default-first-option>
              <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.label">
                <span class="fl">{{ item.label }}</span>
                <span class="select-flex">{{ item.phone }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="$refresh(getSchedulesData, true)">查询</el-button>
            <el-button icon="el-icon-refresh" @click="$reset(getSchedulesData, { doctorName: null })">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    <!-- 操作按钮 -->
      <div class="btn">
        <el-form inline>
          <el-button icon="el-icon-plus" @click="addFree" type="primary" v-if="deptId">新增义诊</el-button>
          <el-button icon="el-icon-setting" @click="setAllowTimeList" type="primary">批量设置放号时间</el-button>
          <el-button icon="el-icon-delete" type="danger" @click="cancelFreeList">批量取消</el-button>
        </el-form>
      </div>
      <!-- 义诊列表 -->
      <el-table v-loading="loading" ref="multipleSelection" :data="freeList" :max-height="tableHeight"
        @selection-change="val => $handleSelectionChange(val, true)" border>
        <el-table-column type="selection" width="40" :selectable="lineDisable"/>
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="doctorName" label="义诊医生"/>
        <el-table-column prop="deptName" label="义诊医馆" v-if="!deptId"/>
        <el-table-column prop="schedulingTime" label="义诊日期" min-width="100"/>
        <el-table-column prop="freeAllocationTime" label="放号时间" min-width="140"/>
        <el-table-column prop="timeName" label="班次"/>
        <el-table-column prop="clinicName" label="诊室"/>
        <el-table-column prop="registrationFreeNumber" label="限号/个"/>
        <el-table-column prop="updateBy" label="操作员" min-width="120"/>
        <el-table-column prop="createTime" label="创建时间" min-width="160"/>
        <el-table-column label="操作" width="230" fixed="right">
          <template slot-scope="scope">
            <el-button icon="el-icon-setting" @click="setAllowTime(scope.row)" type="primary" :disabled="scope.row.freeAllocationTime != null">设置放号</el-button>
            <el-button :disabled="scope.row.status == '1'" icon="el-icon-delete" type="danger"
              @click="cancelFree(scope.row.schedulingItemId)" >取消义诊</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- 新增义诊弹框 -->
      <el-dialog class="dialogEdit" title="新增义诊" :visible.sync="dialogVisible" width="340px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
        <el-form :model="editForm" ref="editForm" :rules="editFormRules" label-width="80px" inline>
          <el-form-item label="医生姓名" prop="doctorId">
            <el-select v-model="editForm.doctorId" placeholder="请选择医生" filterable default-first-option>
              <el-option v-for="item in doctorOptions" :key="item.value" :label="item.label" :value="item.value">
                <span class="fl">{{ item.label }}</span>
                <span class="select-flex">{{ item.phone }}</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="排班班次" prop="timeIds">
            <el-select v-model="editForm.timeIds" multiple :multiple-limit="1" placeholder="请选择班次" filterable default-first-option>
              <el-option v-for="item in shiftOptions" :key="item.value" :label="item.label" :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="排班日期" prop="schedulingTime">
            <el-date-picker v-model="editForm.schedulingTime" value-format="yyyy-MM-dd" type="date" placeholder="选择排班日期" :picker-options="pickerOptions"/>
          </el-form-item>
          <el-form-item label="坐诊诊室" prop="clinicName">
            <el-select v-model="editForm.clinicName" placeholder="请选择医生诊室" filterable default-first-option>
              <el-option v-for="item in clinicOptions" :key="item.value" :label="item.label" :value="item.label"/>
            </el-select>
          </el-form-item>
          <el-form-item label="义诊数量" prop="registrationFreeNumber">
            <el-input v-model.number="editForm.registrationFreeNumber" placeholder="请输入义诊数"><template slot="append">个</template></el-input>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="addSave">保存新增</el-button>
          <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
        </span>
      </el-dialog>
      <!-- 设置放号时间弹框 -->
      <el-dialog class="dialogEdit" title="设置义诊放号时间" :visible.sync="setAllowVisible" width="330px" :before-close="$handleClose">
        <el-form :model="freeTimeForm" ref="freeTimeForm">
          <el-form-item label="放号时间" prop="freeAllocationTime">
            <el-date-picker v-model="freeTimeForm.freeAllocationTime" value-format="yyyy-MM-dd HH:mm"
            type="datetime" :picker-options="pickerOptions" placeholder="选择放号时间"/>
          </el-form-item>
        </el-form>
        <!-- 操作按钮 -->
        <span slot="footer" class="dialog-footer">
          <el-button icon="el-icon-setting" type="primary" @click="saveAllowTime" class="ml10">保存</el-button>
          <el-button @click="$cancel('setAllowVisible')">取 消</el-button>
        </span>
        </el-dialog>
      <!-- 分页 -->
      <el-pagination @current-change="page => $handleCurrentChange(page, getSchedulesData)" :total="total"
      :current-page="currentPage" :page-size="pageSize" layout="total, prev, pager, next, jumper"/>
    </div>
  </div>
</template>

<script lang="js">
import { shiftList } from "@/api/shift"; // 班次请求
import { clinicList } from "@/api/clinic"; // 诊室列表请求
import { scheduleFreeList, scheduleAdd, scheduleFreeTime, freeCancel } from "@/api/schedule"; // 排班请求
export default {
  name: "Free",
  data() {
    return {
      loading: true,
      currentPage: 1, // 当前页
      pageSize: 10, // 显示条数
      total: 0, // 总条数
      freeList: [], // 义诊列表
      multipleSelection: [], // 多选
      editForm: {}, // 新增义诊
      shiftOptions: [], // 班次列表
      clinicOptions: [], // 诊室列表
      pickerOptions:{ // 日期不可选范围
        disabledDate(time) {
          return time.getTime() < Date.now() - 24 * 60 * 60 * 1000 || time.getTime() > Date.now() + 14 * 24 * 60 * 60 * 1000;
        }
      },
      dialogVisible: false, // 新增模态框
      setAllowVisible: false, // 设置放号时间模态框
      freeTimeForm: { freeAllocationTime: null }, // 放号表单对象
      editFormRules: {
        doctorId: [{required: true, message: "医生姓名不能为空！", trigger: "change"}],
        timeIds: [{required: true, message: "班次名称不能为空！", trigger: "change"}],
        schedulingTime: [{required: true, message: "排班日期不能为空！", trigger: "change"}],
        clinicName: [{required: true, message: "坐诊诊室不能为空！", trigger: "change"}],
        registrationFreeNumber: [{required: true, message: "义诊数量不能为空！"}, {type: 'number', message: "数量格式为数字！"}]
      }, // 验证规则
      deptId: this.$session.get('deptId'), // 医馆id
      searchForm: { doctorName: null }, // 查询表单
      tableHeight: 0, // 表格最大高度]
      schedulingItemIds: [], // 选中需要修改时间的项
    }
  },
  props: { doctorOptions: Array }, // 接收父组件传递的参数
  created() {
    this.tableHeight = document.documentElement.clientHeight - 330;
    this.getSchedulesData();
    this.getShiftsData();
    this.getClinicsData();
  },
  methods: {
    // 请求所有义诊排班
    async getSchedulesData() {
      let { total, rows, code } = await scheduleFreeList({ pageNum: this.currentPage, pageSize: this.pageSize, ...this.searchForm });
      if (code == 200) {
        if(total > 0){
          rows.forEach(item => { 
            item.timeName = item.schedulingTimeInfo.timeName;
            this.$session.get("options").forEach(items => {
              if (item.deptId == items.value) item.deptName = items.label;
            });
          });
        }
        this.freeList = rows;
        this.total = total;
      }
      this.loading = false;
    },
    // 请求所有班次列表
    async getShiftsData() {
      let { total, rows, code } = await shiftList();
      if (total > 0 && code == 200) rows.forEach(item => {
        this.shiftOptions.push({ label: item.timeName, value: item.timeId });
      });
    },
    // 请求所有诊室列表
    async getClinicsData() {
      let { total, rows, code } = await clinicList();
      if (total > 0 && code == 200) rows.forEach(item => {
        this.clinicOptions.push({ label: item.clinicName, value: item.clinicId });
      });
    },
    // 新增义诊
    addFree() {
      this.editForm = {
        doctorId: null, timeIds: [], timeId: null, schedulingTime: null, clinicName: null,
        registrationFreeNumber: null, deptId: this.deptId, isPhysio: 0, isContributing: 0,
        registrationCommonNumber: 0, registrationContributingNumber: 0, registrationPhysioNumber: 0, isFree: 2
      }
      this.dialogVisible = true;
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          let params = JSON.parse(JSON.stringify(this.editForm));
          this.doctorOptions.forEach(item => { if (params.doctorId == item.value) params.doctorName = item.label })
          scheduleAdd(params).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("新增义诊排班成功！");

            this.dialogVisible = false;
            this.$refresh(this.getSchedulesData);
            this.$refs['editForm'].resetFields();
          })
        } else return false;
      })
    },
    // 取消义诊
    cancelFree(schedulingItemId) {
      this.$confirm('确认取消该义诊？').then(_ => { this.remove(schedulingItemId) }).catch(_ => {});
    },
    async remove(id) {
      let { code } = await freeCancel(id);
      if (code == 200) this.$message.success("取消义诊成功！");
      this.$refresh(this.getSchedulesData);
    },
    // 批量取消义诊
    cancelFreeList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何义诊项！");
      else {
        selected.forEach(item => { selectedId.push(item.schedulingItemId) });
        this.$confirm('确认取消该义诊？').then(_ => { this.remove(selectedId) }).catch(_ => {});
      }
    },
    // 重置排班查询表单
    reset() {
      this.searchForm = { doctorName: null };
      this.$refresh(this.getSchedulesData);
      $reset(getSchedulesData, { doctorName: null })
    },
    // 保存放号时间设置
    async saveAllowTime() {
      let params = {};
      if (this.freeTimeForm.freeAllocationTime != null) {
        params = { freeAllocationTime: this.freeTimeForm.freeAllocationTime, schedulingItemIds: this.schedulingItemIds }
        let { code } = await scheduleFreeTime(params);
        if (code == 200) {
          this.$message.success("设置放号时间成功！");
          this.setAllowVisible = false;
          this.$refresh(this.getSchedulesData);
        }
      } else this.$message.error("您未选择放号时间，请选择后再试");
    },
    // 批量设置放号时间
    setAllowTimeList() {
      let selected = [...this.multipleSelection];
      let selectedId = [];
      if (selected.length == 0) this.$message.error("您未选中任何义诊排班项！");
      else {
        selected.forEach(item => { selectedId.push(item.schedulingItemId) });
        this.schedulingItemIds = selectedId;
        this.setAllowVisible = true;
      }
    },
    // 单个设置放号时间
    setAllowTime(obj) {
      this.schedulingItemIds = [ obj.schedulingItemId ];
      this.setAllowVisible = true;
    },
    // 多选框禁用
    lineDisable(row) {
      if (row.freeAllocationTime != null) return false;
      else return true;
    }
  }
};
</script>

<style lang="less" scoped>
  .free {
    box-sizing: border-box;
    padding: 20px;
  }

  /deep/.el-input {
    width: 260px !important;
  }
</style>